/*
 * @Author: w
 * @Date: 2022-03-31 18:09:27
 * @LastEditors: w
 * @LastEditTime: 2022-07-27 18:21:29
 */
import { createApp } from "vue";
import store from "@/stores";
import { defineStore } from "pinia";
import Request from "@/api/module";

import { setToken, setRefreshToken, getReFreshToken, removeReFreshToken, removeToken } from "@/scripts/token";

import extend from "extend";
import {
  asyncRoutes,
  declareRoutes,
  drawbackRoutes,
  agreementRouters,
  drawbackRoutesOst,
  uploadUtilsRoutes,
  fpaManagement,
  financeRouters,
  orderRouters,
  accountingRouters,
  consultationRouters,
  warehousingRouters
} from "@/router/asyncRoutes";
import router from "@/router";
import { ar } from "element-plus/lib/locale";
import commonRouters from '../../router/comonRouters';
let PROMIS_CACHE: any = {};
let PARAMETER_CACHE: any = {};
const companyType = sessionStorage.getItem('companyType')
// 提取链接
// 生成isMenu是false的映射

function isMenuNot(data: Array<any>, map: any, allMap: any) {
  map = map || {
    "/home": { path: "/home" },
  };
  allMap = allMap || {
    "/home": { path: "/home" },
  };
  data.forEach((item) => {
    const url = item.path;
    const isMenu = item.meta.isMenu;
    if (url) {
      allMap[url] = item;
      if (!isMenu) {
        map[url] = item;
      }
    }
    if (item.children && item.children.length) {
      isMenuNot(item.children, map, allMap);
    }
  });
  return {
    map,
    allMap,
  };
}
const renderMap = isMenuNot(
  [
    ...asyncRoutes,
    declareRoutes,
    drawbackRoutes,
    agreementRouters,
    drawbackRoutesOst,
    uploadUtilsRoutes,
    fpaManagement,
    consultationRouters,
  ],
  {},
  {}
);
const isMenuMap = renderMap.map;
const allMap = renderMap.allMap;

function hasRole(data: any, map: any) {
  if (!data.roles || data.roles.length === 0) {
    return true;
  }

  return data.roles.some((v: any) => {
    return map[v] !== undefined;
  });
}

function extract(
  data: Array<any>,
  map: any,
  menuList: Array<any>,
  needRoleMap: any
) {
  map = map || {
    "/home": {
      name: "首页",
      path: "/home",
    },
  };
  menuList = menuList || [];
  data.forEach((item) => {
    const url = item.path;
    const isMenu = isMenuMap[url];
    const boolean = hasRole(item.meta, needRoleMap);

    if (url && boolean) {
      map[url] = item;
    }
    var one = extend(true, {}, item);
    one.children = [];
    if (!isMenu && boolean) {
      menuList.push(one);
    }
    if (item.children && item.children.length) {
      extract(item.children, map, one.children, needRoleMap);
    }
  });

  return { map, menuList };
}
export const useInfoStore = defineStore("main", {
  state: () => ({
    token: "",
    menuList: [],
    menuMap: {},
    $keycloak: {},
    currentCompany: "",
    companyList: [],
    roleList: [],
    breadcrumbList: [],
    currentPage: 1,
    total: 0,
    refreshPage: true,
    isDeclare: false, //是否有报关、退税模块权限，（主要控制工具下载显示隐藏）
    isUpload: false,
    currencyObject:{},//一个键为币制枚举值，值为币制中文名的对象
    currencyList:[],//所有币制的集合
    quantityObject:{},//一个键数量单位枚举值，值为数量单位中文名的对象
    quantityList:[],//所有数量单位的集合
    userData: {},
    currentPlatform: {},
    assignAccountData: {},     //是否指定账号
  }),
  getters: {},
  actions: {
    cleanPromisCache () {
      PROMIS_CACHE = {}
    },
    setkeyCloak(obj: Object) {
      this.$keycloak = obj;
    },
    keyclockLogin(token: string) {
      this.token = token;
      setToken(token);
    },
    menuListSet(data: any) {
      this.menuList = data;
    },
    menuMapSet(data: any) {
      this.menuMap = data;
    },
    setCurrentCompany(data: any) {
      this.currentCompany = data;
    },
    setCompanyList(data: any) {
      this.companyList = data;
    },
    setRefreshPage(data: any) {
      this.refreshPage = data;
    },
    setTotal(data: any) {
      this.total = data;
    },
    setCurrency(data:any){
      this.currencyObject = data
    },
    setCurrencyList(data:any){
      this.currencyList = data
    },
    setQuantity(data:any){
      this.quantityObject = data
    },
    setQuantityList(data:any){
      this.quantityList = data
    },
    async updateUserInfo () {
      //新增用户接口调整，方便调用用户信息
      await Request.getUserMessage().then(({ data }) => {
        this.userData = data.data
      })
      //不同平台的平台方企业 目前有明灏、领秀两个平台
      await Request.getPlatformInfo().then(({data}) => {
        if (data.code == 0) {
          this.currentPlatform = data.data
        }
      })
    },
    async asssignAccount() {
      await Request.getAssistantCheck().then(({data}) => {
        this.assignAccountData = data.data
      })
    },
    //登录后获取公司菜单模块权限流程
    async getMenuAndCurrentCompany() {
      /*
      问题：设计是用户注册到keycloak那边，并没有到我们的数据库
      解决方式：
      1.成功后------->调用:   organization/current      当前企业
      2.重新获取token
      3.调用----------->/user/app/lease  获取模块
      4.调用---------->organization/page/1            获取企业列表

      注：不能直接调用：organization/page/1   必须先走完前面流程

      更改为 
       1.调用------->:   organization/current      当前企业
       2.调用----------->/user/app/lease  获取模块
       3.调用---------->organization/page/1 获取企业列表
      */

      //是否指定账号，用于AI去掉首页等
      await this.asssignAccount()
      let data:any
      data = await this.getUserMenu();
     //获取当前企业
      let msgData = await this.getCurrentCompany(); 
      window.localStorage.setItem("platformType", msgData?.data?.platformType ?? msgData?.platformType);
      window.localStorage.setItem("currentCompanyId", msgData.id);
      window.localStorage.setItem("electronicPortDxpType", msgData.data.electronicPortDxpType);

      // var code = msgData.code;
      // if (
      //   code === 0 &&
      //   msgData.data.name !== "无组织人员组织" &&
      //   msgData.data.name !== "暂未加入企业"
      // ) {
      //   data = await this.getUserMenuAll();
      // } else {
      //   data = await this.getUserMenu();
      // }
      //新增用户接口调整，方便调用用户信息
      await this.updateUserInfo()
      //获取企业列表
      this.getCompanyList(1);
      this.getOrdercommonUnitEach()
      this.getQuantity()
      // router.replace({
      //   path:'/home'
      // })
      return data;
    },
    // 获取当前用户所在的公司
    async getCurrentCompany () {
      if (PROMIS_CACHE.CURRENTCOMPANY) {
        return PROMIS_CACHE.CURRENTCOMPANY;
      }
      
      return Request.getCurrentCompany().then(({ data }) => {
          PROMIS_CACHE.CURRENTCOMPANY = data.data;
          this.setCurrentCompany(data.data);
          return data;
        })
        .catch((err) => {
          if (!err) {
            return;
          }
          if (err.code === 603) {
            this.setCurrentCompany({
              name: "没有企业",
            });
            PROMIS_CACHE.CURRENTCOMPANY = err.msg;
            return err;
          } else {
            PROMIS_CACHE.CURRENTCOMPANY = [];
          }
        });
    },
    getTreeData(useroute: Array<any>, parent: any) {
      for (let i = 0; i < useroute.length; i++) {
        if (useroute[i].children && useroute[i].children.length > 0) {
          this.getTreeData(useroute[i].children, useroute[i].name);
        }
        router.addRoute(parent, useroute[i]);
      }
    },
    // 生成路由表
    async generateRoute(data: any) {
      return new Promise((resolve) => {
        let list = extend(true, [], asyncRoutes);
        var dataMap: any = {};
        data.data.forEach((key: any) => {
          dataMap[key.id] = key;
          // console.log(dataMap);
          if (key.id == "TAX_REIMBURSEMENT") {
            list.splice(4, 0, drawbackRoutesOst);
            this.getTreeData([drawbackRoutesOst], "drawBacks");
          }
          if (key.title == "我的企业") {
            //工具下载
            list.splice(1, 0, uploadUtilsRoutes);
            this.getTreeData([uploadUtilsRoutes], "uload");
            this.isUpload = true;
          }
          if (key.title == "报关") {
            list.splice(2, 0, declareRoutes);
            this.getTreeData([declareRoutes], "declare");
            this.isDeclare = true;
          } else if (key.title == "退税") {
            list.splice(3, 0, drawbackRoutes);
            this.getTreeData([drawbackRoutes], "drawback");
            this.isDeclare = true;
          } else if (key.title == "我的企业") {
            list[1].children?.push(agreementRouters);
            this.getTreeData([agreementRouters], "enterpriseRelation");
          } else if (key.title == "数据管理") {
            list.splice(6, 0, fpaManagement);
            this.getTreeData([fpaManagement], "fpaManagement");
          } else if (key.title == "金融服务") {
            list.splice(7, 0, financeRouters);
            this.getTreeData([financeRouters], "finance");
          }else if (key.title == "单证管理") {
            list.splice(8, 0,orderRouters);
            this.getTreeData([orderRouters], "orders");
          }
          else if (key.title == "问诊") {
            list.splice(9, 0, consultationRouters);
            this.getTreeData([consultationRouters], "consultationRouters");
          }
          else if (key.title == "财务") {
            list.splice(10, 0,accountingRouters);
            this.getTreeData([accountingRouters], "accounting");
          } 
          else if (key.title == "仓储") {
            list.splice(11, 0,warehousingRouters);
            this.getTreeData([warehousingRouters], "warehousing");
          } 
        });
        const one = extract(list, {}, [], dataMap);
        const copy = extend(true, [], one);
        // this.menuListSet(copy.menuList);
        // const homeRoute = { id: "HOME", href: "/", title: "首页" };
        // data.data.unshift(homeRoute);
        //const newMenus = commonRouters.concat(data.data)
        //data.data.push(financeRoute)
        //console.table(data.data)
        const homeRoute = {
          id: "HOME",
          href: "/home",
          title: "首页",
        };
        if (companyType !== 'yc') {
          data.data.unshift(homeRoute);
        }
        this.menuListSet(data.data);
        this.menuMapSet(copy.map);
        var obj = {
          routerList: copy.menuList,
          routerMap: copy.map,
        };
        PROMIS_CACHE.MENULIST = obj;

        return resolve(obj);
      });
    },

    // 获取默认用户的用户菜单
    getUserMenu() {
      // if (PROMIS_CACHE.MENULIST) {
      //   return PROMIS_CACHE.MENULIST
      // }
      return Request.getOrgPerson().then(({ data }: any) => {
        if (PROMIS_CACHE.MENULIST) {
          const homeRoute = {
            id: "HOME",
            href: "/home",
            title: "首页",
          };
          if (companyType !== 'yc') {
            data.data.unshift(homeRoute);
          }
          this.menuListSet(data.data);
          return;
        } else {
          return this.generateRoute(data);
        }
      });
    },
    getUserMenuAll() {
      console.log('---------------getUserAll')
      if (PROMIS_CACHE.MENULIST) {
        return PROMIS_CACHE.MENULIST;
      }
      return Request.getMenuByAll().then(({ data }: any) => {
        return this.generateRoute(data);
      });
    },

    // 获取用户的企业列表
    getCompanyList(current: number) {
      if (PROMIS_CACHE.COMPANYLIST) {
        return PROMIS_CACHE.COMPANYLIST;
      }
      // <<<<<<< HEAD
      //       return Request.getEnterpriseList(current, {}).then(({ data }: any) => {
      // =======
      // return Request.getEnterpriseList(current, { name: "", code: "" })
      return Request.getEnterpriseList({ "page": current, "pageSize": 10})
        .then(({ data }: any) => {
          var arr = data.data?.data?.records;
          this.setTotal(data.data?.data?.total);
          this.setCompanyList(arr);
        })
        .catch(() => {});
    },
    //获取币制
    getOrdercommonUnitEach(){
      let data:any = {}
      Request.getOrdercommonUnitEach('CURRENCY').then(res =>{
        if(res.data.data && res.data.data.length>0){
          this.setCurrencyList(res.data.data)
         res.data.data.forEach((item:any) =>{
          data[item.name] = item.message
          data[item.message] = item.name
         })
         this.setCurrency(data)
        }
      })
     },
     //获取数量单位
     getQuantity(){
      let data:any = {}
      Request.getOrdercommonUnitEach('QUANTITY').then(res =>{
        if(res.data.data && res.data.data.length>0){
          this.setQuantityList(res.data.data)
         res.data.data.forEach((item:any) =>{
          data[item.name] = item.message
          data[item.message] = item.name
         })
         this.setQuantity(data)
        }
      })
     },
    // 切换企业
    async toggleCompany(params: any) {
      const { data } = await Request.toggleCompany(
        params.id,
        params.keycloakRefreshToken
      );
      if (data.code === 0) {
        await Request.getRefreshToken({refresh_token: data.data.refresh_token}).then(res=>{
          removeReFreshToken()
          setRefreshToken(res.data.data.refresh_token)
          removeToken()
          setToken(res.data.data.access_token)
        })
        if (!params.boolean) {
          const url = location.href;
          if (location.href.indexOf("enterprise/management/managementList") != -1) {
            const newurl = url.substr(0, url.indexOf("?"));
            window.location.href = newurl + `?page=${this.currentPage}`;
            location.reload();
          } else {
            location.reload();
            window.location.href = "/";
          }
        }
      }
    },
    regetCompanyList() {
      PROMIS_CACHE.COMPANYLIST = null;
      this.companyList = [];
    },
    regetCurrentCompany() {
      PROMIS_CACHE.CURRENTCOMPANY = null;
    },
    // 保存面包屑
    setBreadcrumb(data: any) {
      var arr: any = [];
      data.forEach((v: any) => {
        if (v.meta.title !== "") {
          var obj = {
            path: v.path,
            name: v.name,
            title: v.meta.title,
          };
          arr.push(obj);
        }
      });
      this.breadcrumbList = arr;
    },
    // setBreadcrumb(data: any) {
    //   var arr: any = [];
    //   var obj = {
    //     path: data.path || '',
    //     name: data.name || '',
    //     title: data.meta.title ||'',
    //   }
    //   debugger
    //   const isHasIndex = arr.findIndex((item:any) =>item.name == obj.name)
    //   if(isHasIndex <0){
    //     arr.push(obj)
    //   }
    //   this.breadcrumbList = arr;
    // },
    // 获取角色的字典
    getRoleDirectory() {
      if (PARAMETER_CACHE.ROLE) {
        return Promise.resolve([]);
      }
      return Request.getUserRole().then(({ data }) => {
        var arr = data.data || [];
        this.roleList = arr;
        PARAMETER_CACHE.ROLE = arr;
        return Promise.resolve(arr);
      });
    },
    currentPageChange(data: any) {
      this.currentPage = data;
      this.getCompanyList(data);
    },
    // reFreshToken(refresh_token:any){
    //   Request.getRefreshToken({refresh_token}).then(({data})=>{
    //     console.log(data.data.refresh_token,'reFreshToken的方法');
    //     this.setRefreshTokenVal(data.data.refresh_token)

    //   })
    // }
  },
});

/** 在 setup 外使用 */
export function useInfoStoreHook() {
  return useInfoStore(store);
}
